import React, {useContext, useState} from 'react';
import {Button, Checkbox, Form, Input, Steps, theme, Typography} from 'antd';
import {ApiContext} from "../../../ApiContext";
import "./DeleteAccount.css"
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {getCurrentUser, setCurrentUser} from "../../../store/CommonSlice";
import {setAuth} from "../../../store/AuthSlice";
import AmfyLogo from "../../../layout/AmfyLogo";


const DeleteAccount = () => {
    const {txt, afterLogin, saveToStore, showSuccess} = useContext(ApiContext);
    const {token} = theme.useToken();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(0);
    // Согласие из шага 2 держим на уровне компонента (а не внутри JSX шага),
    // чтобы перерисовки по таймеру не сбрасывали его.
    const [step2Checked, setStep2Checked] = useState(false);
    const currentUser = useSelector(getCurrentUser);

    // После удаления аккаунта JWT ещё какое-то время валиден, поэтому на вебе
    // принудительно разлогиниваем пользователя, чтобы по «назад» нельзя было
    // вернуться в приложение под удалённым аккаунтом.
    const logoutAfterDeletion = () => {
        dispatch(setAuth({accessToken: '', refreshToken: ''}));
        dispatch(setCurrentUser({uuid: ''}));
        saveToStore('access_token', '');
        saveToStore('refresh_token', '');
        showSuccess(txt('security.deleteAccount.deletedMessage'));
        navigate('/home');
    };

    const [deleteAccountConfirmationToken, setDeleteAccountConfirmationToken] = useState();
    const [canSendCode, setCanSendCode] = useState(true);
    const [timeRemaining, setTimeRemaining] = useState();

    const updateTime = (seconds) => {
        try {
            if (seconds >= 0) {
                setTimeRemaining(seconds)
                setTimeout(updateTime, 1000, --seconds);
            } else {
                setCanSendCode(true);
            }
        } catch (error) {
            console.error(error);
        }
    }


    const doSendCode = (moveNext) => {
        const body = {oldToken: deleteAccountConfirmationToken};
        axios.post('/user/delete_account_create_token', body)
            .then((genericResponse) => {
                if (genericResponse.error == '') {
                    setDeleteAccountConfirmationToken(genericResponse.data.token)
                    console.log(genericResponse.data.token);
                    if (moveNext) next();
                }
            }).catch(error => {
        }).finally(() => {
                setCanSendCode(false);
                updateTime(40);
            }
        );
    };

    const doLoginForVerification = (formData) => {
        const body = {login: currentUser.email, password: formData.password};
        axios.post('/user/login', body)
            .then((genericResponse) => {
                if (genericResponse.error == '') {
                    console.log(genericResponse);
                    afterLogin(genericResponse);
                    next()
                }
            }).catch(error => {
            console.log(error);
        });
    };

    const doCheckDeleteAccountCode = (values) => {
        const body = {code: values.code, token: deleteAccountConfirmationToken};
        console.log(body);
        axios.post('/user/delete_account_check_code', body)
            .then((genericResponse) => {
                if (genericResponse.error == '') {
                    // аккаунт удалён — разлогиниваемся и уходим на страницу входа
                    logoutAfterDeletion();
                }
            }).catch(error => {
        });
    };


    /**
     * Конвертирует отсчетное время в секундах в формат mm:ss
     * @param timeInSeconds отсчетное время в секундах
     * @returns {`${string}:${string}`} отсчетное время в формате mm:ss
     */
    const formatSecondsToTime = (timeInSeconds) => {
        const minutes = String(Math.floor(timeInSeconds / 60)).padStart(2, '0');
        const seconds = String(timeInSeconds % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    // Содержимое шагов задаём как обычный JSX (а не как вложенные компоненты Step1/Step2/Step3).
    // Иначе на каждый тик таймера пересоздавался бы тип компонента, React перемонтировал бы
    // поддерево шага, и поле ввода кода теряло бы фокус и введённые цифры каждую секунду.
    const steps = [
        {
            title: txt("security.deleteAccount.step1.title"),
            content: (
                <div>
                    <Form
                        name="passwordVerify"
                        onFinish={doLoginForVerification}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: txt("register.fieldShouldBeNotBlank"),
                                },
                            ]}
                        >
                            <Input.Password
                                placeholder={txt("register.password")}
                                autoComplete="no-password"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">{txt("security.verifyButton")}</Button>
                        </Form.Item>
                    </Form>
                </div>
            ),
        },
        {
            //todo добавить кучу уведомлений и подтверждений для мастера, владельца бизнеса, для того кто куда то записан
            title: txt("security.deleteAccount.step2.title"),
            content: (
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <Checkbox checked={step2Checked} onChange={(e) => setStep2Checked(e.target.checked)}>
                        {txt("security.deleteAccount.step2.verificationCheckbox")}
                    </Checkbox>
                    <Button
                        type="primary"
                        danger
                        disabled={!step2Checked}
                        onClick={() => doSendCode(true)}
                    >
                        {txt("security.deleteAccount.step2.proceedDeleteButton")}
                    </Button>
                </div>
            ),
        },
        {
            title: txt("security.deleteAccount.step3.title"),
            content: (
                <Form
                    name="codeVerify"
                    onFinish={doCheckDeleteAccountCode}
                    autoComplete="off"
                >
                    <Form.Item
                        name="code"
                        rules={[
                            {
                                required: true,
                                message: txt("register.fieldShouldBeNotBlank"),
                            },
                        ]}
                    >
                        <Input.OTP length={4} formatter={(str) => str.toUpperCase()}/>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            {txt("security.deleteAccount.step3.deleteAccountButton")}
                        </Button>
                    </Form.Item>
                    <Button
                        type="text"
                        disabled={!canSendCode}
                        onClick={() => doSendCode(false)}
                    >
                        {canSendCode
                            ? txt("security.deleteAccount.resendCode")
                            : `${txt("security.deleteAccount.resendCodeAfter")} (${formatSecondsToTime(timeRemaining)})`
                        }
                    </Button>
                </Form>
            ),
        },
    ];
    const next = () => {
        setCurrentStep(currentStep + 1);
    };
    const prev = () => {
        setCurrentStep(currentStep - 1);
    };
    const items = steps.map(item => ({key: item.title, title: item.title}));
    const contentStyle = {
        textAlign: 'center',
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
        padding: 24,
    };
    const {Title, Paragraph} = Typography;
    const howItWorks = txt("security.deleteAccount.info.howItWorks");
    return (
        <div className="delete-account-page">
            <AmfyLogo/>
            <Typography style={{textAlign: 'left'}}>
                <Title level={3}>{txt("security.deleteAccount.info.title")}</Title>
                <Paragraph>{txt("security.deleteAccount.info.intro")}</Paragraph>
                <Title level={5}>{txt("security.deleteAccount.info.howItWorksTitle")}</Title>
                <ol>
                    {Array.isArray(howItWorks) && howItWorks.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ol>
                <Title level={5}>{txt("security.deleteAccount.info.dataTitle")}</Title>
                <Paragraph type="secondary">{txt("security.deleteAccount.info.dataText")}</Paragraph>
            </Typography>
            <Steps current={currentStep} items={items}/>
            <div style={contentStyle}>{steps[currentStep].content}</div>
        </div>
    );
};
export default DeleteAccount;

